import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Eye, Droplets } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { TreatmentsCarousel } from './TreatmentsCarousel';
export function ServicesMenu() {
  const {
    t
  } = useLanguage();
  const serviceImages: Record<string, string> = {
    [t('services.s1_name')]: 'https://cdn.magicpatterns.com/uploads/rhkH99xdykiLyX7WK9kgLJ/TRATAMIENTO_PROFUNDO.png',
    [t('services.s2_name')]: 'https://cdn.magicpatterns.com/uploads/uxXLsvBF3BgAdf29eq4Gjh/HYDRAFACIAL.png',
    [t('services.s5_name')]: 'https://cdn.magicpatterns.com/uploads/6Sfbim9J4kUbv54WTwoR3m/CARBOXY_TERAPIA.png',
    [t('services.s8_name')]: 'https://cdn.magicpatterns.com/uploads/73HutjDmfRhRP3wGvZQiCo/PEEL_QUIMICO.png',
    [t('services.s10_name')]: 'https://cdn.magicpatterns.com/uploads/vgYJ4aJDw8n7TosnbZ5H83/DERMAPLANING.png',
    [t('services.s7_name')]: 'https://cdn.magicpatterns.com/uploads/dYzfpzo79VLeg8fCsbKdU5/TRATAMIENTO_FACIAL.png',
    [t('services.s9_name')]: 'https://cdn.magicpatterns.com/uploads/6jueZi8VWt5vdpNotgUdpF/GREEN_PEEL.png',
    [t('services.o3_name')]: 'https://cdn.magicpatterns.com/uploads/541fLq17Gm13GDNttSXou7/JELLY_MASK.png',
    [t('services.o4_name')]: 'https://cdn.magicpatterns.com/uploads/oNYbmg7vts7obM4iTR8pVH/EXTRACCIONES_EN_UN_SOLO_LUGAR.png',
    [t('services.o5_name')]: 'https://cdn.magicpatterns.com/uploads/khCnfqFyPUNMW416u5s4KK/REMOCION_DE_VERRUGAS.png'
  };
  const mainServices = [{
    name: t('services.s1_name'),
    desc: t('services.s1_desc')
  }, {
    name: t('services.s2_name'),
    desc: t('services.s2_desc')
  }, {
    name: t('services.s3_name'),
    desc: t('services.s3_desc')
  }, {
    name: t('services.s4_name'),
    desc: t('services.s4_desc')
  }, {
    name: t('services.s5_name'),
    desc: t('services.s5_desc')
  }, {
    name: t('services.s6_name'),
    desc: t('services.s6_desc')
  }, {
    name: t('services.s7_name'),
    desc: t('services.s7_desc')
  }, {
    name: t('services.s8_name'),
    desc: t('services.s8_desc')
  }, {
    name: t('services.s9_name'),
    desc: t('services.s9_desc')
  }, {
    name: t('services.s10_name'),
    desc: t('services.s10_desc')
  }, {
    name: t('services.s11_name'),
    desc: t('services.s11_desc')
  }, {
    name: t('services.s12_name'),
    desc: t('services.s12_desc')
  }, {
    name: t('services.s13_name'),
    desc: t('services.s13_desc')
  }, {
    name: t('services.s14_name'),
    desc: t('services.s14_desc')
  }, {
    name: t('services.s15_name'),
    desc: t('services.s15_desc')
  }];
  const otherServices = [{
    name: t('services.o1_name'),
    desc: t('services.o1_desc')
  }, {
    name: t('services.o2_name'),
    desc: t('services.o2_desc')
  }, {
    name: t('services.o3_name'),
    desc: t('services.o3_desc')
  }, {
    name: t('services.o4_name'),
    desc: t('services.o4_desc')
  }, {
    name: t('services.o5_name'),
    desc: t('services.o5_desc')
  }];
  return <section id="servicios" className="py-12 md:py-24 bg-brand-cream relative" data-id="element-421" data-mp="1tcl0oc96n3rc">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-422" data-mp="1tep30prfnupi">
        <div className="text-center mb-10 md:mb-16" data-id="element-423" data-mp="1oe9ss72g73br">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-424" data-mp="1jmrrtj0fd2qs">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-425" data-mp="1an4nopgb9iu1">
              {t('services.title')}
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full mb-6" data-id="element-426" data-mp="10o73tzttydhd"></div>
            <p className="text-brand-charcoal max-w-2xl mx-auto mb-8" data-id="element-427" data-mp="10q9sogj8y0ki">
              {t('services.subtitle')}
            </p>
            <a href="https://book.heygoldie.com/tairu-aesthetics" target="_blank" rel="noopener noreferrer" className="btn-gold-animated relative overflow-hidden inline-flex items-center gap-2 text-white px-8 py-3 rounded-sm font-medium transition-all duration-300 shadow-lg shadow-brand-gold/30 ring-1 ring-brand-gold-light/40 hover:shadow-brand-gold/50 hover:-translate-y-0.5 text-sm" data-id="element-428" data-mp="2v1y7mipha34w">
              <span aria-hidden="true" className="sheen pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 skew-x-[-20deg] bg-white/25 blur-md" data-id="element-429" data-mp="2o5n91e9l2aeg" />
              <Sparkles className="relative w-4 h-4" data-id="element-430" data-mp="2t3f0662elshl" />
              <span className="relative" data-id="element-431" data-mp="2fdlchr2mxe9g">{t('header.bookNow')}</span>
            </a>
          </motion.div>
        </div>

        {/* Treatments Carousel */}
        <TreatmentsCarousel data-id="element-432" data-mp="2k5la3cv8fv2v" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-433" data-mp="25f5kllvsa0yw">
          {/* Main Services List */}
          <motion.div className="lg:col-span-8" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-434" data-mp="2ae8fwelyosto">
            <div className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10 h-full" data-id="element-435" data-mp="20hvl1deok8xc">
              <div className="flex items-center gap-3 mb-8 pb-4 border-b border-brand-gold/20" data-id="element-436" data-mp="1htlfoa6bahq9">
                <Sparkles className="w-6 h-6 text-brand-gold" data-id="element-437" data-mp="1cv0ea7fbps08" />
                <h3 className="text-2xl font-serif text-brand-brown" data-id="element-438" data-mp="1qt8agd4jcpac">
                  {t('services.main_title')}
                </h3>
              </div>

              <div className="divide-y divide-brand-gold/10" data-id="element-439" data-mp="20qcy6he14st9">
                {mainServices.map((service, idx) => <div key={idx} className="flex items-start gap-4 md:gap-6 py-5 first:pt-0 last:pb-0 group" data-id="element-440" data-mp="1vrrsw3jx7ixy" data-mpi={idx}>
                    {serviceImages[service.name] && <div className="w-24 h-28 md:w-32 md:h-36 flex-shrink-0 overflow-hidden rounded-sm border border-brand-gold/30 shadow-sm" data-id="element-441" data-mp="29hn0oy713za3">
                        <img src={serviceImages[service.name]} alt={service.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110" data-id="element-442" data-mp="2jh43n7uwbz2d" />
                      </div>}
                    <div className="flex-1 min-w-0" data-id="element-443" data-mp="1c5mshxd4kfgs">
                      <h4 className="font-semibold text-brand-charcoal mb-1 group-hover:text-brand-gold transition-colors" data-id="element-444" data-mp="1c2s9895ul0oy">
                        {service.name}
                      </h4>
                      <p className="text-sm text-gray-600 leading-relaxed" data-id="element-445" data-mp="1l36w3cygmnuk">
                        {service.desc}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>
          </motion.div>

          {/* Sidebar Services */}
          <motion.div className="lg:col-span-4 space-y-8" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-446" data-mp="1zscs6s203xy8">
            {/* Eyes & Brows */}
            <div className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10" data-id="element-447" data-mp="eguwkse5fpkx">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-brand-gold/20" data-id="element-448" data-mp="eio224d103rc">
                <Eye className="w-6 h-6 text-brand-gold" data-id="element-449" data-mp="6z54mt31c7z8" />
                <h3 className="text-xl font-serif text-brand-brown" data-id="element-450" data-mp="25tuoj2xfb33">
                  {t('services.eyes_title')}
                </h3>
              </div>

              <div className="space-y-6" data-id="element-451" data-mp="3oe3hq8pdb2pt">
                <div data-id="element-452" data-mp="3of4s0ayk7l6h">
                  <h4 className="font-semibold text-brand-charcoal mb-1" data-id="element-453" data-mp="3ofmvnsnjx1of">
                    {t('services.e1_name')}
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-454" data-mp="kwlao3hf5zqg">
                    {t('services.e1_desc')}
                  </p>
                </div>
                <div data-id="element-455" data-mp="fwffwefurx45">
                  <h4 className="font-semibold text-brand-charcoal mb-1" data-id="element-456" data-mp="g036b4q043en">
                    {t('services.e2_name')}
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-457" data-mp="30ohjpokqetje">
                    {t('services.e2_desc')}
                  </p>
                </div>
              </div>
            </div>

            {/* Other Services */}
            <div className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10" data-id="element-458" data-mp="zkyh4i0q4n74">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-brand-gold/20" data-id="element-459" data-mp="14m5rmou940hh">
                <Droplets className="w-6 h-6 text-brand-gold" data-id="element-460" data-mp="qm3a53puv92r" />
                <h3 className="text-xl font-serif text-brand-brown" data-id="element-461" data-mp="vkenhofd01pq">
                  {t('services.other_title')}
                </h3>
              </div>

              <div className="divide-y divide-brand-gold/10" data-id="element-462" data-mp="1jaiqbtkq3xfo">
                {otherServices.map((service, idx) => <div key={idx} className="flex items-start gap-4 py-4 first:pt-0 last:pb-0 group" data-id="element-463" data-mp="1nb2mattk8v08" data-mpi={idx}>
                    {serviceImages[service.name] && <div className="w-20 h-24 flex-shrink-0 overflow-hidden rounded-sm border border-brand-gold/30 shadow-sm" data-id="element-464" data-mp="19icxkhmndbzf">
                        <img src={serviceImages[service.name]} alt={service.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110" data-id="element-465" data-mp="228bh5xi2ogwp" />
                      </div>}
                    <div className="flex-1 min-w-0" data-id="element-466" data-mp="2gctzh2942vgu">
                      <h4 className="font-semibold text-brand-charcoal text-sm" data-id="element-467" data-mp="2cd1lga0y7x43">
                        {service.name}
                      </h4>
                      <p className="text-xs text-gray-600" data-id="element-468" data-mp="2q3oogedqs95z">{service.desc}</p>
                    </div>
                  </div>)}
              </div>
            </div>

          </motion.div>
        </div>
      </div>
    </section>;
}